export const environment = {
  production: true,
  client_id: 'dbb93efb-6a0d-4e8d-a9fc-069d79c4f6b1',
  app_url: 'https://acc.entitlement-amce.es.xom.cloud/',
  base_api_url: 'https://ext.apiproxyuat.exxonmobil.com/sccot-amce-entitlement/v1',
  base_api_scope: 'api://sccot-csit-amce-entitlement-nonprod/access_as_user',
  base_api_swagger:
    'https://ext.apiproxyuat.exxonmobil.com/acc-entitlement-amce//v1/swagger/v1/swagger.json',
};
